'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _mockedFreeMerchandiseItems = require('self-service-api/constants/mockedFreeMerchandiseItems');

var _mockedFreeMerchandiseItems2 = _interopRequireDefault(_mockedFreeMerchandiseItems);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var merchandiseAdapter = function merchandiseAdapter(merchandiseCatalog) {
  return merchandiseCatalog.reduce(function (accumulator, merchandiseItem) {
    accumulator.products[merchandiseItem.id] = merchandiseItem;

    return accumulator;
  }, { authState: 'NOT_AUTHED', products: _extends({}, _mockedFreeMerchandiseItems2.default) });
};

exports.default = merchandiseAdapter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/adapters/merchandiseAdapter.js
// module id = 888
// module chunks = 4